import { render, staticRenderFns } from "./listaUnidades.vue?vue&type=template&id=74da50ce&scoped=true"
import script from "./listaUnidades.vue?vue&type=script&lang=js"
export * from "./listaUnidades.vue?vue&type=script&lang=js"
import style0 from "./listaUnidades.vue?vue&type=style&index=0&id=74da50ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da50ce",
  null
  
)

export default component.exports